const MODULE_NAME = 'owc-highlight-slider';

export const CLASSES = {
  highlightSlider: MODULE_NAME,
  highlightSliderSlide: `${MODULE_NAME}__slide`,
  highlightSliderSlideActive: `${MODULE_NAME}__slide--isActive`,
  highlightSliderBar: `${MODULE_NAME}__slider-bar`,
  highlightSliderBarLabel: `${MODULE_NAME}__label`,
  highlightSliderBarLabelLeft: `${MODULE_NAME}__slider-bar--isLabelLeft`,
  highlightSliderButton: `${MODULE_NAME}__slider-button`,
};

export const WB_SLIDER_THEME_VALUES = {
  lightTheme: 'light',
  darkTheme: 'dark',
};
